export default {
  query: {
    search: 'Search',
    duration: 'Duration',
    to: 'to',
    timezone: 'Time Zone',
    range: 'Data Range',
    day: 'Day',
    quarter: 'Quarter',
    month: 'Month',
    productName: 'Product Name',
    package: 'Package',
    creativeName: 'Creative Name',
    dcoId: 'DCO ID',
    dcoVersionName: 'DCO Version Name',
    combinationId: 'Group ID',
    dataDimension: 'Data Dimension',
    dataIndex: 'Data Index',
    preview: 'Preview',
  },
  list: {
    total: 'Total',
    product: 'Product Name',
    package: 'Package Name',
    creativeName: 'Creative Name',
    dcoVersionName: 'DCO Version Name',
    combinationId: 'Group ID',
    date: 'Date',
    month: 'Month',
    quarter: 'Quarter',
    impression: 'Impression',
    click: 'Click',
    install: 'Install',
  },
  button: {
    search: 'Search',
    reset: 'Reset',
    unfold: 'Unfold',
    preview: 'Preview',
    export: 'Export',
  },
}
